import { NzConfig } from 'ng-zorro-antd/core/config';
import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';

export const ngZorroConfig: NzConfig = {
  message: { nzTop: '10px', nzDirection: 'ltr' },
  notification: { nzBottom: 50, nzPlacement: 'bottom', nzDuration: 6000 },
};

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};

export const icons: IconDefinition[] = Object.keys(antDesignIcons).map((key) => antDesignIcons[key]);
